import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NzModalRef} from 'ng-zorro-antd/modal';
import {MfaService} from '../../../pages/login/service/mfa.service';
import {AuthService} from '../../../pages/login/service/auth.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-mfa-otp',
  templateUrl: './mfa-otp.component.html',
  styleUrls: ['./mfa-otp.component.scss']
})
export class MfaOtpComponent implements OnInit {

  /** mfaToken nhận từ login response */
  @Input() mfaToken: string;

  otpForm: FormGroup;
  isLoading = false;
  errorMessage: string = null;

  constructor(
    private fb: FormBuilder,
    private modalRef: NzModalRef,
    private mfaService: MfaService,
    private authService: AuthService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.otpForm = this.fb.group({
      otp: [null, [Validators.required, Validators.minLength(6), Validators.maxLength(6), Validators.pattern('^[0-9]{6}$')]]
    });
  }

  confirm(): void {
    if (this.otpForm.invalid) {
      Object.values(this.otpForm.controls).forEach(c => {
        c.markAsDirty();
        c.updateValueAndValidity({onlySelf: true});
      });
      return;
    }

    this.isLoading = true;
    this.errorMessage = null;
    const otp = this.otpForm.get('otp').value;

    this.mfaService.verifyMfa(this.mfaToken, otp).subscribe(
      res => {
        this.isLoading = false;
        if (res && res.access_token) {
          this.authService.saveStorage(res);
          this.modalRef.close({success: true});
          this.router.navigate(['']);
        } else {
          this.errorMessage = res?.message ?? 'Xác thực thất bại. Vui lòng thử lại.';
        }
      },
      error => {
        this.isLoading = false;
        switch (error?.messageCode) {
          case 'MFA_INVALID_OTP':
            this.errorMessage = 'Mã OTP không hợp lệ. Vui lòng thử lại.';
            break;
          case 'MFA_TOKEN_EXPIRED':
            this.errorMessage = 'Phiên xác thực đã hết hạn. Vui lòng đăng nhập lại.';
            this.modalRef.close({expired: true});
            break;
          default:
            this.errorMessage = error?.message ?? 'Có lỗi xảy ra. Vui lòng thử lại.';
        }
      }
    );
  }

  cancel(): void {
    this.modalRef.close(null);
  }

  /** Chỉ cho phép nhập số */
  onOtpKeyPress(event: KeyboardEvent): boolean {
    return /[0-9]/.test(event.key);
  }
}
